import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { CustomerDeliveryReport } from "../../models/Delivery-Executive/DeliveryExecutive";
import orderServices from "../../services/orders/orderservice";
 
export const exportCustomerDeliveryReport = async () => {
  try {
    const response = await orderServices.getCustomerDeliveryReport();
    if (!response) {
      console.warn("No data received for Customer Delivery Report.");
      return;
    }
    generatePDFCustomerDelivery(response);
  } catch (error) {
    console.error("Error fetching Customer Delivery Report:", error);
    throw error;
  }
};
 
const generatePDFCustomerDelivery = (reportList: CustomerDeliveryReport[]) => {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });
 
  const tableData: any[] = [];
 
  reportList.forEach((order) => {
    let totalQty = 0;
 
    if (order.products && order.products.length > 0) {
      order.products.forEach((product, index) => {
        totalQty += product.quantity;
 
        tableData.push([
          index === 0 ? order.sequenceNo : "",
          index === 0 ? order.orderId : "",
          index === 0 ? order.customerContact : "",
          index === 0 ? order.customerName : "",
          index === 0
            ? `${order.address1 ?? ""}, ${order.address2 ?? ""}, ${
                order.landmark ?? ""
              }, ${order.areaName}, ${order.subDistrictName} ${
                order.districtName
              } ${order.zipcode}`
            : "",
          index === 0 ? order.paymentMode || "" : "",
          index === 0 ? order.paymentStatus || "" : "",
          product.productName,
          product.quantity,
          Math.round(Number(product.productAmount)) || 0,
        ]);
      });
 
      // 👇 Add summary row for each order
      tableData.push([
        "Total",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        totalQty,
        Math.round(Number(order.totalAmount)) || 0,
      ]);
    } else {
      tableData.push([
        order.sequenceNo,
        order.orderId,
        order.customerContact,
        order.customerName,
        `${order.address1 ?? ""}, ${order.address2 ?? ""}, ${
          order.landmark ?? ""
        }, ${order.areaName}, ${order.subDistrictName} ${
          order.districtName
        } ${order.zipcode}`,
        order.paymentMode || "",
        order.paymentStatus || "",
        "",
        "",
        "",
      ]);
    }
  });
 
  autoTable(doc, {
    head: [
      [
        "Sq#",
        "Order#",
        "Mobile#",
        "Customer Name",
        "Address",
        "Order Payment Type",
        "Order Payment Status",
        "Product Name",
        "Quantity",
        "Total Value",
      ],
    ],
    body: tableData,
    styles: { fontSize: 8, cellPadding: 1 },
    headStyles: { fillColor: [41, 128, 185] },
    columnStyles: {
      4: { cellWidth: 70 }, // Address
      7: { cellWidth: 50 }, // Product name
    },
    didParseCell: function (data) {
      if (data.cell.raw === "Total") {
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.fontSize = 9;
      }
      if (data.row.cells[0]?.raw === "Total") {
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.fontSize = 9;
      }
    },
  });
 
  doc.save("CustomerDeliveryReport.pdf");
};
 
 